//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {fileutil} from "@/util/fileutil"
import {Toast} from "vant";
import {commonTool} from "@/util/base"
import areaCascader from '@/pages/common/areaCascader/areaCascader'
import md5 from "js-md5";
export default {
  name: 'createAndBindCompanyForm',
  components: {
    areaCascader
  },
  data () {
    return {
      userInfo: this.$store.getters.getUserInfo,
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      fileutil,
      appInfo: {},
      industrysCheck: [],
      industrys: [],
      image: {}
    }
  },
  methods: {
    showForm (app) {
      console.log('showForm app ===>', app)
      this.appInfo = JSON.parse(JSON.stringify(app))
      this.userInfo = this.$store.getters.getUserInfo
      this.initIndustrysCheck()
      this.visible = true
    },
    initIndustrysCheck () {
      const obj = {
        dictId: 'industry',
        appId: this.appInfo.id
      }
      this.industrys = []
      this.industrysCheck = []
      this.$store.dispatch('company/querySysDictItemByDictIdAndAppId', JSON.stringify(obj))
        .then(res => {
          this.industrys = res.data.objs
          this.industrysCheck = res.data.objs
          console.log('initIndustrysCheck res ===>', res)
        }).catch(err => {
          console.log('initIndustrysCheck err ===>', err)
        })
    },
    handleCancel () {
      this.form.resetFields()
      this.image.url = null
      this.visible = false
    },
    settingHeaders () {
      // 设置验证参数， 用户不校验是否登录调用接口
      let timestamp = new Date().getTime() + '';
      let radom = Math.random() + '';
      let str = timestamp + radom + '1'
      let token = md5(str)
      return { timestamp: timestamp, radom: radom, crossToken: token,crossType: 1 }
    },
    beforeUpload(file) {
      return fileutil.beforeUploadOnlyImg(this, file)
    },
    handleFileChange(info) {
      const status = info.file.status
      if (status === 'done') {
        this.image = info.file.response.obj
        this.$message.success(`${info.file.name} 图片上传成功`)
      } else if (status === 'error') {
        this.$message.error(`${info.file.name} 图片上传失败`)
      }
    },
    changeAreaData(value) { // 设置地区的值
      this.form.setFieldsValue({
        area: value
      })
    },
    fnSaveCompany () {
      console.log('this.userInfo===>', this.userInfo)
      if (this.userInfo && this.userInfo.id) {
        this.form.validateFields((error, values) => {
          this.fnSave(values)
        })
      } else {
        Toast('未登录')
      }
    },
    fnSave(values) {
      const companyInfo = this.fnCreateObj(values)
      companyInfo.ccFileInfoBo = this.fnCreateFileInfoBo(companyInfo)
      let ccCompanyBindSaasBo = {
        ccCompanyBo: companyInfo,
        ucUserBo: this.userInfo,
        bindType: 1
      }
      console.log("ccCompanyBindSaasBo ===>", ccCompanyBindSaasBo)
      this.$store.dispatch('company/freeTrySaasSystem', JSON.stringify(ccCompanyBindSaasBo))
        .then(res => {
          console.log('confirmBind res ===>', res)
          if (res.data && res.data.retCode == 1) {
            Toast('绑定成功')
            this.handleCancel()
            this.visible = false
          } else {
            Toast(res.data.retMsg)
          }
        }).catch(err => {
          console.log('confirmBind err ===>', err)
        })
    },
    fnCreateObj (values) {
      const obj = {};
      obj.companyName = values.companyName;
      if (this.industrysCheck.length == 1) {
        obj.industry = this.industrysCheck[0].itemValue
      } else {
        obj.industry = values.industry
      }
      obj.industryName = this.industrys.find(a => a.itemValue == obj.industry).itemName
      obj.useAppId = this.industrys.find(a => a.itemValue == obj.industry).appId
      obj.country = '中华人民共和国'
      obj.province = values.area.province
      obj.city = values.area.city
      obj.area = values.area.district
      obj.countryCode = '-1'
      obj.provinceCode = values.area.provinceCode
      obj.cityCode = values.area.cityCode
      obj.areaCode = values.area.districtCode
      // obj.address = values.address
      obj.legalPerson = values.legalPerson
      obj.qualityImageGroupId = commonTool.generateUUID()
      obj.qualityImage = this.image.url
      obj.bindSaasState = 0
      obj.bindSaasNum = 1
      obj.trialState = 1
      obj.formalState = 0
      obj.expireState = 0
      obj.openState = 0
      obj.rejectState = 0
      obj.aiCertificate = 0;
      obj.openIm = 0;
      obj.createUserId = this.userInfo.id
      obj.ucUserId = this.userInfo.id
      obj.ucUserName = this.userInfo.realName == null ? this.userInfo.nickName : this.userInfo.realName
      obj.ucUserPhone = this.userInfo.userPhone
      return obj
    },
    fnCreateFileInfoBo(data) {
      const obj = {}
      obj.appId = data.useAppId
      obj.groupId = data.qualityImageGroupId
      obj.url = this.image.url
      obj.disLocal = obj.url
      obj.zipUrl = obj.url
      obj.zipDisLocal = obj.url
      obj.fileSource = '00007'
      obj.fixName = this.image.fileType
      obj.fileType = commonTool.getFileType(obj.fixName)
      obj.fileName = this.image.fileName
      obj.userId = data.createUserId
      obj.sort = 1
      obj.isUse = 1
      return obj
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/modules/createAndBindCompanyForm.vue